import { createContext } from 'react';
import { AppThemeContextType } from '../types';

const AppThemeContext = createContext<AppThemeContextType | undefined>(undefined);

export { AppThemeContext };
